import { Modal, Box, IconButton } from "@mui/material";
import Close from "@zenith/assets/icons/Close";
import EmailIcon from "@zenith/assets/icons/components/EmailIcon";
import CallIcon from "@zenith/assets/icons/Call";
import { ButtonComponent } from "@zenith/components";
import {
  FINOPAY_SUPPORT_MAIL,
  FINOPAY_SUPPORT_TEL_NG,
} from "@zenith/data/constants";

interface ContactSupportModalProps {
  open: boolean;
  onClose: () => void;
}

const ContactSupportModal = ({ open, onClose }: ContactSupportModalProps) => (
  <Modal open={open} onClose={onClose}>
    <Box className="absolute top-1/2 left-1/2 w-[90%] max-w-[438px] -translate-x-1/2 -translate-y-1/2 rounded-[20px] bg-white outline-none">
      <div className="flex justify-end px-4 pt-4">
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className="flex flex-col items-center gap-4 px-6 pb-8">
        <h5 className="text-xl font-semibold text-neutral-900">
          Contact Support
        </h5>
        <p className="text-sm text-neutral-600">
          Kindly reach out to us for support on
        </p>
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <EmailIcon width={18} height={18} />
            <span className="text-sm text-neutral-800">
              {FINOPAY_SUPPORT_MAIL}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <CallIcon />
            <span className="text-sm text-neutral-800">
              {FINOPAY_SUPPORT_TEL_NG.replace(
                /(\+\d{3})(\d{3})(\d{3})(\d{4})/,
                "$1-$2-$3-$4"
              )}
            </span>
          </div>
        </div>
        <ButtonComponent
          label="Close"
          type="outline"
          size="large"
          id="contact-support-close"
          onClick={onClose}
          className="mt-4 w-full rounded-[8px]"
        />
      </div>
    </Box>
  </Modal>
);

export default ContactSupportModal;
